import { useSelector } from "react-redux";
import "./AmMonitorHome.scss";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  TablePagination,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import { IoIosRefresh } from "react-icons/io";
import { CiImageOn } from "react-icons/ci";
import { MdAdd, MdArrowBackIos, MdClose } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { IoDocumentTextSharp } from "react-icons/io5";
import newRequest from "../../../utils/newRequest";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import { getCssValue } from "../../../utils/genericFunctions";
import { useTranslation } from "react-i18next";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";
import moment from "moment";

const AmMonitorHome = () => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [confirmationActiontext, setConfirmationActiontext] = useState("");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [searchTerm, setSearchTerm] = useState("");
  const [funds, setFunds] = useState([]);
  const [selectedFund, setSelectedFund] = useState(null);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: ""
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentFundPage, setCurrentFundPage] = useState(0);
  const [selectedClass, setSelectedClass] = useState(null);
  const [assetClasses, setAssetClasses] = useState([]);
  const [reportGroupArray, setReportKeysArray] = useState(["am-funds"]);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const location = useLocation();
  const showBack = location.state?.showBack || "N";

  const handleFundPageChange = (event, newPage) => {
    setCurrentFundPage(newPage);
  };

  const handleFundRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentFundPage(0);
  };


  const filteredFunds = funds?.filter(
    (row) =>
      row?.fund_code?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      row?.fund_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      row?.ticker_symbol?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const paginatedFunds = filteredFunds?.slice(
    currentFundPage * rowsPerPage,
    currentFundPage * rowsPerPage + rowsPerPage
  );

  const fetchFunds = async (firstTime) => {
    try {
      if (firstTime) {
        setIsLoading(true);
      } else {
        setIsProcessing(true);
      }
      const res = await newRequest.post("/fund/findAll", { result_limit: 100 });
      setFunds(res.data);
      setIsLoading(false);
      setIsProcessing(false);
    } catch (error) {
      setIsLoading(false);
      setIsProcessing(false);
    }
  };



  const handleSearchFunds = async () => {
    try {
      setIsLoading(true);
      if (searchTerm) {
        const res = await newRequest.post("/fund/search", { search_input: searchTerm });
        setFunds(res.data);
      } else {
        fetchFunds();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFunds(true);
  }, []);

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "openVisit") {

      }

    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  return (
    <div className="fund-monitor">
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <motion.div
          className="fund-monitor-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}>
          <div className="fund-monitor-center-wrapper">
            <div className="center-navbar">
              <div className="navbar-left">{t('funds').toUpperCase()}</div>
              <div className="navbar-right">
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="left"
                  endIcon={<IoIosRefresh />} onClick={fetchFunds}>
                  {t('refresh')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="right"
                  endIcon={<IoDocumentTextSharp />}
                  onClick={() => setReportsDialogOpen(true)}>
                  {t('reports')}
                </CustomLoadingButton>
                {/* This part shows if the menu was opened from home screen */}
                {showBack === "Y" && <hr className="separator-v" />}
                {showBack === "Y" &&
                  <span className="back-icon" onClick={() => navigate(-1)}>
                    <MdArrowBackIos size={24} />
                  </span>}
              </div>
            </div>
            <div className="center-content">
              <div className="table-content">
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                          <div className="search-input-wrapper" style={{ display: "flex", width: "100%" }}>
                            <FiSearch className="search-input-icon" />
                            <input
                              className="search-input"
                              type="text"
                              placeholder={`${t('search')} ${t('fund')}`}
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') handleSearchFunds();
                              }}
                            />
                            {searchTerm.length > 0 && (
                              <MdClose
                                onClick={async (e) => {
                                  try {
                                    setSearchTerm("");
                                    await fetchFunds();
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                className="search-input-icon"
                              />
                            )}
                            {searchTerm?.length === 0 && (
                              <span className="search-input-icon" />
                            )}
                          </div>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                          <span />
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                          <span>{t('status')}</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {paginatedFunds?.map((row, index) => (
                        <TableRow
                          key={row._id}
                          className={`${selectedFund?._id === row._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => {
                            try {
                              setSelectedFund(row);
                              navigate(`/fmon/${row._id}`);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            {currentFundPage * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                            <div className="fund-details">
                              {row?.fund_logo_url ? <img src={row?.fund_logo_url} alt="" className='fund-avatar' />
                                :
                                <CiImageOn style={{ width: "40px", height: "40px" }} />
                              }
                              <div className="fund-name">
                                <span className="name">{row?.fund_name}</span>
                                <span className="code">{row?.fund_code}</span>
                              </div>
                              <div className="fund-name">
                                <span className="name">{`${t('type')} : ${row?.fund_type}`}</span>
                                <span className="code">{`${t('alias')} : ${row?.fund_alias}`}</span>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "250px" }}>
                            <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px" }}>
                              <span className={`status ${row?.fund_status}`} style={{ width: "2px" }} />
                              <div className="fund-name">
                                <span className="name">{`${t('currency')} : ${row?.base_currency}`}</span>
                                <span className="code">{`${t('launch')} ${moment(row?.launch_date).format("DD-MMM-YYYY")}`}</span>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                            <span className={`sub-title xrsmall status ${getCssValue(row?.fund_status)}`}>{row?.fund_status}</span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {funds?.length > funds?.length &&
                    <TablePagination
                      rowsPerPageOptions={[10]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleFundRowsPerPage}
                      component="div"
                      count={funds?.length}
                      rows={funds}
                      page={currentFundPage}
                      onPageChange={handleFundPageChange}
                    />}
                </TableContainer>
              </div>
            </div>
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={reportGroupArray}
                documentData={{
                  docNo: "1",
                  docId: "1",
                  docType: "AM Fund",
                  format: "xlsx",
                  entity_code: "",
                  date_fm: "",
                  date_to: "",
                  status: "",
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}>Close</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle="Confirmation"
        dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
      />
    </div>
  )
}

export default AmMonitorHome